import { createSelector } from '@reduxjs/toolkit';

import { TermsOfUseStatus } from '@/App/types';
import { selectAppConfig } from '@/features/config/selectAppConfig';
import { selectUiState } from '@/features/ui/selectUiState';

export const selectTermsOfUseStatus = createSelector(
  [selectAppConfig, selectUiState],
  ({ termsOfUseEnabled }, { termsOfUseStatus }) => (termsOfUseEnabled ? termsOfUseStatus : TermsOfUseStatus.ACCEPTED),
);
